import { SERVER_API } from 'SharedDir/constants/app/endpoints';
import { IEndpointData } from 'SharedDir/declarations/shared';

const attachmentUrl = `${SERVER_API}/files`;

export const ATTACHMENT_ENDPOINTS = {
  UPLOAD: {
    method: 'POST',
    url: `${attachmentUrl}`,
  } as IEndpointData,
  LIST: {
    method: 'GET',
    url: `${attachmentUrl}`,
  } as IEndpointData,
  GET(fileUID: string): IEndpointData {
    return {
      method: 'GET',
      url: `${attachmentUrl}/${fileUID}`,
    };
  },
  GET_INFO(fileUID: string): IEndpointData {
    return {
      method: 'GET',
      url: `${attachmentUrl}/${fileUID}/info`,
    };
  },
  // UPDATE_INFO оставлен на бэке; фронт сохраняет через UPDATE_INFO_WITH_FILE.
  UPDATE_INFO_WITH_FILE(fileUID: string): IEndpointData {
    return {
      method: 'PUT',
      url: `${attachmentUrl}/${fileUID}/update`,
    };
  },
  DELETE(fileUID: string): IEndpointData {
    return {
      method: 'DELETE',
      url: `${attachmentUrl}/${fileUID}`,
    };
  },
  SIGN(fileUID: string): IEndpointData {
    return {
      method: 'PUT',
      url: `${attachmentUrl}/${fileUID}/sign`,
    };
  },
  GET_SIGNATURE(fileUID: string): IEndpointData {
    return {
      method: 'GET',
      url: `${attachmentUrl}/${fileUID}/signature`,
    };
  },
  GET_USAGES(fileUID: string): IEndpointData {
    return {
      method: 'GET',
      url: `${attachmentUrl}/${fileUID}/usages`,
    };
  },
};
